import { render, staticRenderFns } from "./no-sidebar-narrow-canvas.vue?vue&type=template&id=c016fd68&scoped=true"
import script from "./no-sidebar-narrow-canvas.vue?vue&type=script&lang=js"
export * from "./no-sidebar-narrow-canvas.vue?vue&type=script&lang=js"
import style0 from "./no-sidebar-narrow-canvas.vue?vue&type=style&index=0&id=c016fd68&prod&lang=scss"
import style1 from "./no-sidebar-narrow-canvas.vue?vue&type=style&index=1&id=c016fd68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c016fd68",
  null
  
)

export default component.exports